/**
 * Labstep
 */

import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import { PostFilterMetadatas } from 'labstep-web/services/postFilter/metadatas';

export const getPostFilterMetadatasHasValue = (path: string) =>
  new PostFilterMetadatas(
    [
      ['label', PostFilterComparison.eq],
      ['value', PostFilterComparison.not_null],
    ],
    path,
  );

export const getPostFilterMetadatasDefault = (path: string) =>
  new PostFilterMetadatas(
    [
      ['label', PostFilterComparison.eq],
      ['value', PostFilterComparison.eq],
    ],
    path,
  );

export const getPostFilterMetadatasNumeric = (path: string) =>
  new PostFilterMetadatas(
    [
      ['label', PostFilterComparison.eq],
      ['number', PostFilterComparison.eq],
    ],
    path,
  );

export const getPostFilterMetadatasDate = (path: string) =>
  new PostFilterMetadatas(
    [
      ['label', PostFilterComparison.eq],
      ['date', PostFilterComparison.eq],
    ],
    path,
  );

export const getPostFilterMetadatasDatetime = (path: string) =>
  new PostFilterMetadatas(
    [
      ['label', PostFilterComparison.eq],
      ['date', PostFilterComparison.eq],
    ],
    path,
  );

export const getPostFilterMetadatasOptions = (path: string) =>
  new PostFilterMetadatas(
    [
      ['label', PostFilterComparison.eq],
      ['options', PostFilterComparison.contains],
    ],
    path,
  );

export const getPostFilterMetadatasSequence = (path: string) =>
  new PostFilterMetadatas(
    [['inchis', PostFilterComparison.contains]],
    `${path}.molecule`,
  );

export const getPostFilterMetadatasHasValueWithName = (
  path: string,
) =>
  new PostFilterMetadatas(
    [
      ['name' as any, PostFilterComparison.eq],
      new PostFilterMetadatas(
        [
          ['label', PostFilterComparison.eq],
          ['value', PostFilterComparison.not_null],
        ],
        path,
      ),
    ],
    'protocolValues',
  );

export const getPostFilterMetadatasDefaultWithName = (path: string) =>
  new PostFilterMetadatas(
    [
      ['name' as any, PostFilterComparison.eq],
      new PostFilterMetadatas(
        [
          ['label', PostFilterComparison.eq],
          ['value', PostFilterComparison.eq],
        ],
        path,
      ),
    ],
    'protocolValues',
  );

export const getPostFilterMetadatasNumericWithName = (path: string) =>
  new PostFilterMetadatas(
    [
      ['name' as any, PostFilterComparison.eq],
      new PostFilterMetadatas(
        [
          ['label', PostFilterComparison.eq],
          ['number', PostFilterComparison.eq],
        ],
        path,
      ),
    ],
    'protocolValues',
  );

export const getPostFilterMetadatasDateWithName = (path: string) =>
  new PostFilterMetadatas(
    [
      ['name' as any, PostFilterComparison.eq],
      new PostFilterMetadatas(
        [
          ['label', PostFilterComparison.eq],
          ['date', PostFilterComparison.eq],
        ],
        path,
      ),
    ],
    'protocolValues',
  );

export const getPostFilterMetadatasDatetimeWithName = (
  path: string,
) =>
  new PostFilterMetadatas(
    [
      ['name' as any, PostFilterComparison.eq],
      new PostFilterMetadatas(
        [
          ['label', PostFilterComparison.eq],
          ['date', PostFilterComparison.eq],
        ],
        path,
      ),
    ],
    'protocolValues',
  );

export const getPostFilterMetadatasOptionsWithName = (path: string) =>
  new PostFilterMetadatas(
    [
      ['name' as any, PostFilterComparison.eq],
      new PostFilterMetadatas(
        [
          ['label', PostFilterComparison.eq],
          ['options', PostFilterComparison.contains],
        ],
        path,
      ),
    ],
    'protocolValues',
  );

export const getPostFilterMetadatasSequenceWithName = (
  path: string,
) =>
  new PostFilterMetadatas(
    [
      ['name' as any, PostFilterComparison.eq],
      new PostFilterMetadatas(
        [['inchis', PostFilterComparison.contains]],
        `${path}.molecule`,
      ),
    ],
    'protocolValues',
  );
